import Attachment from '@/types/Attachment'
import { extractFileNameFromUrl } from '@/utils/parsers'

interface Props {
  title?: string
  attachments: Attachment[]
  className?: string
}

export default function AttachmentsList({
  title,
  attachments,
  className,
}: Props) {
  return (
    <div className={`d-flex flex-column gap-2 align-items-sm-center align-items-lg-start ${className}`}>
      {title && <div className="ms-3">{title}</div>}
      <ul className="d-flex flex-column gap-2">
        {attachments.map(attachment => (
          <li key={attachment.id}>
            <a
              href={attachment.url}
              download={attachment.url.split('/').pop()}
              target="_blank"
              rel="noopener noreferrer"
            >
              {extractFileNameFromUrl(attachment.url)}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
